import { Box, Flex, Image, Text } from '@chakra-ui/react'

import IconMoreVertical from '@/components/icons/IconMoreVertical'
import IconPencil from '@/components/icons/IconPencil'
import IconTrash from '@/components/icons/IconTrash'
import { Menu, MenuContent, MenuItem, MenuTrigger } from '@/components/ui/Menu'

import type { Collection } from '@/api/collections'

interface CollectionCardProps {
  collection: Collection
  onClick: (id: string) => void
  onEdit: (id: string) => void
  onDelete: (id: string) => void
}

export default function CollectionCard({
  collection,
  onClick,
  onEdit,
  onDelete
}: CollectionCardProps) {
  const handleCardClick = () => {
    onClick(collection.id)
  }

  const handleMenuClick = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  return (
    <Box
      position="relative"
      cursor="pointer"
      onClick={handleCardClick}
      transition="all 0.2s ease"
      _hover={{ transform: 'translateY(-2px)' }}
    >
      <Box
        position="relative"
        borderRadius="12px"
        overflow="hidden"
        bg="bg.tertiary"
        h="193px"
      >
        {collection.cardImageUrl ? (
          <Image
            src={collection.cardImageUrl}
            alt={collection.name}
            w="100%"
            h="100%"
            objectFit="cover"
          />
        ) : (
          <Box w="100%" h="100%" bg="bg.tertiary" />
        )}
        <Box
          position="absolute"
          top="12px"
          left="11px"
          borderRadius="3px"
          px="4px"
          py="2px"
          bg="bg.surface"
        >
          <Text
            textStyle="label"
            color="text.secondary"
          >
            Graphics: {collection.count}
          </Text>
        </Box>
      </Box>

      <Flex mt="6px" align="center" justify="space-between">
        <Text textStyle="body" fontWeight={600} color="text.primary">
          {collection.name}
        </Text>

        <Menu>
          <MenuTrigger onClick={handleMenuClick} p={0}>
            <Box as="span" display="inline-flex">
              <IconMoreVertical color="text.secondary" />
            </Box>
          </MenuTrigger>
          <MenuContent>
            <MenuItem
              value="edit"
              icon={<IconPencil boxSize={4} />}
              onClick={(e) => {
                e.stopPropagation()
                onEdit(collection.id)
              }}
            >
              Edit IP Group
            </MenuItem>
            <MenuItem
              value="delete"
              icon={<IconTrash boxSize={4} />}
              variant="danger"
              onClick={(e) => {
                e.stopPropagation()
                onDelete(collection.id)
              }}
            >
              Delete
            </MenuItem>
          </MenuContent>
        </Menu>
      </Flex>
    </Box>
  )
}
